import styled from 'styled-components'
import { device } from '../Breakpoints'

const Container = styled.ul`
background: #ffffff;
margin: 0;
padding: 0;
width: 100%;
height: 100%;
display: flex;
align-items: stretch;
font-size: 0.6em;

li {
  text-decoration: none;
  width: 100px;
  text-transform: uppercase;
  text-align: center;
  flex-grow: 1;
  justify-items: center;
  list-style: none;
  border: 1px solid white;
  box-sizing: border-box;
  :nth-child(1) {
    background: linear-gradient(to bottom, #c3c4e8, #8e8fc7);
  }

  :nth-child(2) {
    background: linear-gradient(to bottom, #8ec7b5, #478e8b);
  }

  :nth-child(3) {
    background: linear-gradient(to bottom, #ffda76, #fa7272);
  }

  :nth-child(4) {
    background: linear-gradient(to bottom, #fdd4ae, #e5af7e);
  }
  a {
    font-family: 'Santral Bold';
    font-weight: bold;
    color: #fff;
    text-decoration: none;
    padding: 50px;
    display: block;
  }
  img {
    margin: 0 auto 15px auto;
    display: block;
    align-self: center;
  }

  @media ${device.laptop} {
    width: 100%;
    .mobile {
      display: block;
      height: 75px;
    }
  }
}

@media ${device.mobileL} {
  flex-direction: column;
  max-width: 100%;
  min-width: 200px;
  flex: 1;
  .mobile {
    display: block;
    height: 75px;
  }
  .desktop {
    display: none;
  }
}
`

export default Container